import {
  COMMERCIAL_ROLE,
  RECRUITER_ROLE,
  SUPER_ADMIN_ROLE,
} from 'helper/roles';

// A company's sales rep is a Commercial (510): the api refuses anyone else
// (INVALID_ASSIGNEE).
export const commercialsOf = (team) =>
  team.filter((person) => person.role === COMMERCIAL_ROLE);

// A company's recruiter is a recruiter, or failing that an agency manager:
// the 520 first, then the 500.
export const recruitersOf = (team) => [
  ...team.filter((person) => person.role === RECRUITER_ROLE),
  ...team.filter((person) => person.role === SUPER_ADMIN_ROLE),
];
